import React from "react";

import { Grid } from "@material-ui/core";
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DoneIcon from '@mui/icons-material/Done';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';

import alerter from "../../alerts/alerter"
import service from '../../../plas/user/service.jsx';

export default function AdditionalRoles({ user, roles }) {

  const [saving, setSaving] = React.useState(false);
  const [addingRole, setAddingRole] = React.useState(false);
  const [assignedRoles, setAssignedRoles] = React.useState(user.additionalRoles.filter(item => { return roles.map[item].assignable === true } ));
  const [otherRoles, setOtherRoles] = React.useState(roles.list.filter(item => { return item.assignable === true && !item.mainRole && !user.hasRole(item.id) }));
  const [selectedRole, setSelectedRole] = React.useState(null);

  const addRole = () => {
    setSaving(true);
    setAddingRole(true);
    service.api.users.addRole(user.id,selectedRole.id,(response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        user.additionalRoles = response.result.additionalRoles;
        setAssignedRoles(user.additionalRoles.filter(item => { return roles.map[item].assignable === true }));
        setOtherRoles(roles.list.filter(item => { return item.assignable === true && !item.mainRole && !user.hasRole(item.id) }));
        setSelectedRole(null);
      }
      setSaving(false);
      setAddingRole(false);
    })
  }

  const removeRole = (position) => {
    setSaving(true);
    service.api.users.removeRole(user.id, assignedRoles[position] ,(response) => {
      if (response.error != null) {
        alerter.showError(response.error);
      } else {
        user.additionalRoles = response.result.additionalRoles;
        setAssignedRoles(user.additionalRoles.filter(item => { return roles.map[item].assignable === true }));
        setOtherRoles(roles.list.filter(item => { return item.assignable === true && !item.mainRole && !user.hasRole(item.id) }));
      }
      setSaving(false);
    })
  }

  const onChangeRole = (event, newValue) => {
    setSelectedRole(newValue);
  }

  return (
      <Grid container spacing={2} >
        <Grid item xs={true}>
          <Autocomplete 
            options={otherRoles}
            disabled={saving}
            renderInput={(params) => 
              <TextField
                variant="outlined" 
                id="role"
                label="Roles disponibles"
                name="role"
                {...params}
                fullWidth
                placeholder="Ingresa un rol"/>
            } 
            value={selectedRole}
            onChange={onChangeRole}/>
        </Grid>
        <Grid item xs={'auto'}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%">
            <LoadingButton
              disabled={!selectedRole || saving}
              loadingPosition="start"
              startIcon={<DoneIcon />}
              loading={addingRole}
              variant="contained"
              onClick={addRole}>
              <b>Asignar</b>
            </LoadingButton>
          </Box>
        </Grid>
        <Grid item xs={12} style={{ textAlign: 'left'}}>
          { assignedRoles.map((item, index) => (
            <Chip key={index} disabled={saving} style={{margin: '4px', fontSize: '15px'}} label={roles.map[item].description} variant="outlined" onDelete={() => removeRole(index)}/>
          ))}
        </Grid>
      </Grid>

  );
}
